import type { useI18n } from '@/hooks/useI18n';

type Translate = ReturnType<typeof useI18n>['t'];

/**
 * "Acconto · 2 di 5", oppure la sola posizione quando la rata non ha un titolo.
 *
 * Una riga sola sotto il titolo del viaggio, uguale in tutte le liste di /payments: in
 * scadenza, da confermare, incassate. "1 di 1" non si dice contando -- e' il pagamento
 * unico, e si chiama cosi'.
 */
export const installmentCaption = (
    t: Translate,
    row: { label: string | null; seq: number; installments_count: number }
): string => {
    const position =
        row.installments_count === 1
            ? t('payments.due.singlePayment')
            : t('payments.due.seqOf', { seq: row.seq, total: row.installments_count });
    return row.label ? `${row.label} · ${position}` : String(position);
};
